import { navItemsFor, type NavItem } from '@/lib/nav'
import { useApiQuery } from './useApiQuery'
import { useSession } from './useSession'

/**
 * TK patch 07: whether the signed-in console account may use BD tools.
 *
 * Decided by the server (`/api/v1/tk/bd/me`): administrators always, other
 * accounts when an administrator switched "BD tools permission" on for them, the demo
 * account never. Hiding the nav is presentation only - the tk-edge nginx asks
 * DTK on every `/bd-console/*` call and refuses without the permission.
 */
export interface BdAccess {
  allowed: boolean
  always: boolean
  username: string | null
  provisioned: boolean
}

export const BD_ACCESS_KEY = ['tk', 'bd', 'access'] as const
export const BD_ACCESS_PATH = '/api/v1/tk/bd/me'

export function useBdAccess() {
  const session = useSession()
  return useApiQuery<BdAccess>({
    key: BD_ACCESS_KEY,
    path: BD_ACCESS_PATH,
    enabled: Boolean(session.data),
    poll: 60_000,
    staleTime: 15_000,
    retry: false,
  })
}

/** The nav items for this account: by role, minus BD tools without the permission. */
export function useNavItems(): readonly NavItem[] {
  const session = useSession()
  const bd = useBdAccess()
  const allowed = bd.data?.allowed === true
  return navItemsFor(session.data?.role).filter((item) => !item.bd || allowed)
}
